module.exports = __webpack_public_path__ + "img/key.fa101a59.png";